exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Toolbar[data-v-e7fa94b6] {\n  font-size: 12px;\n  display: grid;\n  grid-template-columns: 50px 1fr;\n  grid-template-rows: 20px 20px;\n  column-gap: 5px;\n  row-gap: 5px;\n  padding: 5px;\n  color: #eeeeee;\n  background-color: #666666;\n}\n.Toolbar_Label[data-v-e7fa94b6] {\n    color: #dddddd;\n}\n.Toolbar_HighlightControllers[data-v-e7fa94b6] {\n    display: grid;\n    grid-template-columns: 100px 100px 100px 100px 100px 220px 100px;\n}\n", ""]);

// exports
